import { render, staticRenderFns } from "./DashFilter.vue?vue&type=template&id=6bc524c4"
import script from "./DashFilter.vue?vue&type=script&lang=js"
export * from "./DashFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports